<template>
  <div class="fmember_home">
    <gc-loading :is-show="loadingShow" />
    <GCHEADER :is-show="!isGteatChefbrowser" des="userview" :webapp-link="topWebappLink" :param="pathId" />
    <!-- <gc-guide :down-show="downShow" @showDwon="getWechat" /> -->
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text=""
      @load="onLoadList"
    >
      <div v-for="(item,index) in dataInfo" :key="index" class="memberList">
        <memberList
          :data-info="item"
        />
      </div>
    </van-list>
    <div v-if="finished" style="color:#969799;font-size:14px;line-height:50px;width:100%;text-align:center;">没有更多了</div>

  </div>
</template>
<script>
import { reactive, toRefs, onBeforeMount } from 'vue'
import memberList from '@/components/memberList'
import { ajaxHttp } from '@/api/api'
import { List } from 'vant'
import utils from '@/utils/utils'
import config from '@/config/config'
import { useRouter } from 'vue-router'
import GCHEADER from '@/components/gc-header'

export default {
  name: 'Home',
  components: {
    vanList: List,
    memberList,
    GCHEADER

  },
  setup() {
    const router = useRouter()
    const state = reactive({
      loadingShow: true,
      topWebappLink: '',
      isGteatChefbrowser: utils.is_mini(),
      dataInfo: [],
      releaseShow: false,
      loading: false,
      finished: false,
      page: 1,
      pathId: ''
    })
    onBeforeMount(() => {
      getCheckTabData()
      state.page++
      state.pathId = router.currentRoute.value.query.id
      state.topWebappLink = `${config.webapplink}/restaurant/food?id=${router.currentRoute.value.query.id}`
    })
    const getCheckTabData = () => {
      const data = {
        page: state.page,
        brand_id: router.currentRoute.value.query.id
      }
      ajaxHttp.$get('/brand/brand_chef', data).then(res => {
        if (res.data && res.data.length > 0) {
          state.dataInfo = [...state.dataInfo, ...res.data]
          state.loading = false
          state.finished = false
        } else {
          state.finished = true
          state.loading = false
        }
        state.loadingShow = false
      })
    }
    const onLoadList = () => {
      console.log(state.page)
      getCheckTabData()
      state.page++
    }
    return { ...toRefs(state), onLoadList, getCheckTabData }
  }
}
</script>
<style scoped>
.member_home{overflow: hidden;width:100%;}
.memberList{width: 359px;height:72px;margin-left: 16px;}

</style>
